export const EMAIL_IN_USE_ERROR_TYPE = 'email-in-use';
